import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { utils } from 'protractor';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { HttperrorhandlerService } from '../../shared/http/httperrorhandler.service';

@Injectable({
  providedIn: 'root'
})
export class DrinkingWaterDataService {

  API_URL = ProjConstants.API_URL_TEMP;
  // APWRIMS_URL = ProjConstants.FORECAST_APWRIMS_API_URL;

  constructor(
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
  ) { }

  getWindData(url: string) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setWindData(data);
          resolve(obj);
        }
      );
    });
    return dataPromise;
  }

  getHeatMap(url: string) {
    const dataPromise = new Promise((resolve, reject) => {
      this.http.get(url).subscribe(
        data => {
          const obj = this.setMapData(data);
          resolve(obj);
        });
    });
    return dataPromise;
  }

  setMapData(data: object) {
    const obj = {};
    let imageUrl = {};
    const imageBounds = [];
    for (const block of Object.keys(data)) {
      for (const property of Object.keys(data[block])) {
        imageUrl = data[block]['heatMapImage'];
        let latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['southWest']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['southWest']['longitude']);
        imageBounds.push(latlongs);
        latlongs = [];
        latlongs.push(data[block]['heatMapImageBound']['northEast']['latitude']);
        latlongs.push(data[block]['heatMapImageBound']['northEast']['longitude']);
        imageBounds.push(latlongs);
      }
      obj['url'] = imageUrl;
      obj['bounds'] = imageBounds;
    }
    return obj;
  }

  setWindData(data: Object) {
    for (const block of Object.keys(data)) {
      const array = [];
      const obj1 = new Object();
      obj1['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 2,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj1['data'] = data[block]['data1'];
      array[0] = obj1;

      const obj2 = {};
      obj2['header'] = {
        parameterUnit: 'm.s-1',
        parameterNumber: 3,
        dx: 0.5,
        dy: 0.5,
        parameterNumberName: 'eastward_wind',
        la1: 40.0,
        la2: 5.0,
        parameterCategory: 2,
        lo2: 100.0,
        nx: 71,
        ny: 71,
        refTime: '2017-02-01 23:00:00',
        lo1: 65.0
      };
      obj2['data'] = data[block]['data2'];
      array[1] = obj2;
      return array;
    }
  }

  getDwsTableData(levelParam: string): Observable<any> {
    return this.http.get<any>(this.API_URL + 'rws/table/' + levelParam).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getULBData(): Observable<any> {
    return this.http.post<any>('http://3.7.236.161:8083/api/city/details', {}).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getMapData(): Observable<any> {
    return this.http.get<any>(this.API_URL + 'rws/locmapdata').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getMandalData(locCode): Observable<any> {
    return this.http.get<any>(this.API_URL + 'rws/locmapdata/' + locCode).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getLocCentroidData(locName): Observable<any> {
    return this.http.get<any>(ProjConstants.API_URL + 'weatherForecast/getLocationMetaData/2b9beab2-1495-4f05-b4da-29761ebeb2ee/' + locName).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getJsonData(): Observable<any> {
    return this.http.get<any>(ProjConstants.GEOSERVER_URL+'geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=forecast%3AANDHRA%20PRADESH_STATE_BLOCK&maxFeatures=1000&outputFormat=application%2Fjson').pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getLocForMapUrban(): Observable<any> {
    return this.http.post<any>('http://3.7.236.161:8083/api/city/details', '').pipe(catchError(this.errorHandler.handleError('Kpi data request', [])))
  }

  getLocForMapUrbanFromGeo(): Observable<any> {
    return this.http.get<any>(ProjConstants.GEOSERVER_URL+'geoserver/forecast/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=forecast%3AAP_ULB&maxFeatures=200&outputFormat=application%2Fjson').pipe(catchError(this.errorHandler.handleError('Kpi data request', [])))
  }

  submitMultiSelect(link, params: any): Observable<any> {
    console.log("Testing the link", link, params)
    return this.http.post<any>(this.API_URL + link, params).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

  getLocationList(params: any) {
    return this.http.post<any>(this.API_URL + 'locations/getChildLocations', params).pipe(catchError(this.errorHandler.handleError('Kpi data request', [])))
  }

  uploadData(postdata) {
    return this.http.post<any>(this.API_URL + "uws/UploadUlbCsv", postdata);
  }

  getCumulativeRainfall(params: any) {
    return this.http.post<any>(this.API_URL + 'weatherForecast/cumulativeRainfall', params).pipe(catchError(this.errorHandler.handleError('cumulative Rainfall data request', [])))
  }

  getULBTableData(params) {
    return this.http.post<any>(this.API_URL + 'uws/getULBData', params).pipe(
      catchError(this.errorHandler.handleError('Kpi data request', []))
    );
  }

}
